import React, {useState} from 'react';
import styles from './ButtonSwitch.module.css';

const ButtonSwitchcomponent = ({id, onClick, value, setValue}:any) => {

    const [active, setActive] = useState('on');
    const [checked, setChecked] = useState(true);

    function handleClickSwitch({target}:any) {
        onClick();
        setChecked(target.checked)
        if (checked) {    
            setActive('on');
            setValue('Disponivel')
        } else {
            setActive('off');
            setValue('Indisponivel')
        }
    }

    return (
        <div className={styles.container}>
            {/* {console.log(value)} */}
           <input value={value.length === 0 ? 'Indisponível' : 'Disponível'} type="checkbox" id={id} onChange={handleClickSwitch} checked={checked}/>
           <label htmlFor={id}></label>
        </div>
    )
}

export default ButtonSwitchcomponent;
